import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TopTabsState {
    activeTabs: number[];
}

const initialState: TopTabsState = {
    activeTabs: [0],
};

const slice = createSlice({
    name: 'topTabs',
    initialState,
    reducers: {
        setActiveTabs: (state, action: PayloadAction<number[]>) => {

            state.activeTabs = action.payload;
        },
    },
});

export const topTabsReducer = slice.reducer;
export const { setActiveTabs } = slice.actions;
